<gatewee-input-v2
  [form]="form"
  [controlName]="controlName"
  [id]="id"
  [label]="label"
  [placeholder]="placeholder"
  [required]="required"
  [submitted]="submitted"
  [mask]="documentMask"
  [max]="maxLength"
  [customMessages]="resolvedCustomMessages"
  [hint]="hint"
  [info]="info"
  [isLoading]="isLoading"
  [readonly]="readonly"
  [class]="class"
  type="text"
  (blur)="onBlur()"
  (focus)="focus.emit($event)"
></gatewee-input-v2>
